import React from "react";
import { Component } from "react";
import { Switch } from "react-router-dom";
import FixedView from "../FixedView";
import FieldItem from "./FieldItem";
import { Draggable, DragDropContext, Droppable } from "react-beautiful-dnd";
import { getBoundingClientRect } from "../../utils/functions";
import { translate } from "../../utils/useful";

class SortedBy extends Component {
  state = {
    sortby: [
      { id: "a", item: "Name", src: "/assets/icons/name.svg" },
      { id: "b", item: "Priority", src: "/assets/icons/priority.svg" },
      { id: "c", item: "Flagged", src: "/assets/icons/flagged.svg" },
      { id: "d", item: "Assignee", src: "/assets/icons/assignee.svg" },
      { id: "e", item: "Start date", src: "/assets/icons/calendar.svg" },
      { id: "f", item: "Date", src: "/assets/icons/calendar.svg" },
    ],
    characters: [],
    search: "",
    default: [],
    sortedby: [],
    sortedBy: {},
    sortType: -1
  };

  componentDidMount() {
    // if (this.props.data) {
    //   this.setState({ data: this.props.data })
    // }
    this.init()
    this.setState({ sortedby: this.props.headers }, () => {
      this.setState({ characters: this.state.sortedby });
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.headers != this.props.headers) {
      this.init()
    }
    if (prevProps.data != this.props.data) {
      this.setState({ data: this.props.data })
    }
    if (JSON.stringify(prevProps.view?.settings) != JSON.stringify(this.props.view?.settings)) {
      // console.log('componentDidUpdate')
      this.init()
    }
  }

  init() {
    let defaultt = []
    if (this.props.view?.settings) {
      this.setState({ default: [] }, () => {
        // console.log('this.props.view.settings.groupBy', this.props.view.settings.groupBy)
        if (this.props.view?.settings?.sortedBy) {
          if (Array.isArray(Object.entries(this.props.view?.settings?.sortedBy)) && Object.entries(this.props.view?.settings?.sortedBy)?.length > 0) {
            Object.keys(this.props.view.settings.sortedBy)?.forEach((el) => {
              this.props.headers.forEach((item) => {
                if (item.key == el) {
                  let prop = item
                  if (!prop.sortType) {
                    prop.sortType = this.props.view.settings.sortedBy[el]
                  }
                  // prop.sortType == this.props.view.settings.sortedBy[el]
                  defaultt.push(prop)
                }
              })
            })
            // console.log('defaultt', defaultt)
            // this.makeList()
          }
        }
        if (this.props.view?.settings?.sortedBy) {
          this.setState({ sortedBy: this.props.view?.settings?.sortedBy })
        }
        this.setState({ default: defaultt }, () => {
          // console.log('defaultdefault', this.state.default)
        })
      })
    }
  }

  onDragEnd = (result) => {
    // console.log("hello", result);
    let items = Array.from(this.state.default);
    let [reorderItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderItem);
    this.setState({ default: items }, () => {
      this.makeList()
    });
  };
  openSortView = () => {
    this.sortView.showView();
  };

  openitemView = () => {
    this.itemView.showView();
  };

  searchInput = (e) => {
    this.setState({ search: e.target.value }, () => {
      this.filterHandler(e);
    });
  };
  filterHandler = () => {
    let sortby = [...this.state.sortby];
    let temp = [];
    for (let i = 0; i < sortby.length; i++) {
      let content = sortby[i];
      if (content.information.label.toLowerCase().includes(this.state.search.toLowerCase())) {
        temp.push(content);
      }
    }
    this.setState({ characters: temp }, () => {
      this.state.search = ""
    });
  };
  selectHandler = (item) => {
    let defaultt = JSON.parse(JSON.stringify(this.state.default));
    defaultt.push(item);
    this.makeList(JSON.parse(JSON.stringify(defaultt)))
    // let sortedby = this.state.sortedby
    // let key = item.key
    // let sortType = this.state.sortType
    // sortedby.push({ [key]: sortType })
    this.setState({ default: defaultt }, () => {
      this.sortView.hideView()
    })
  };


  crossHandler = (item) => {
    let arr = JSON.parse(JSON.stringify(this.state.default));
    let characters = JSON.parse(JSON.stringify(this.state.characters))
    arr = arr.filter((i) => (i.id != item.id || i.key != item.key));
    characters.push(item)

    this.setState({ default: arr, characters }, () => {
      this.makeList(JSON.parse(JSON.stringify(this.state.default)))
    });
  };

  makeList = (defaultt) => {
    if (!defaultt) {
      defaultt = JSON.parse(JSON.stringify(this.state.default))
    }
    let characters = []
    this.props.headers.forEach(e => {
      if (!defaultt.includes(e)) {
        if (!characters.includes(e)) {
          characters.push(e)
        }
      }
    });

    // let sortedBy = []
    // defaultt.forEach(el => {
    //   sortedBy.push([el.key, this.state.sortType])
    // });

    // let sortedBy = [[], []]
    // defaultt.forEach(el => {
    //   sortedBy[0].push(el.key)
    //   sortedBy[1].push(this.state.sortType)
    // });

    let sortedBy = {}
    defaultt.forEach(el => {
      sortedBy[el.key] = el.sortType ?? this.state.sortType
    });

    console.log('sortedBysortedBy', defaultt)
    this.setState({ characters, sortedBy }, () => {
      this.props.functionsHandler(null, 'changeSortBy', sortedBy, null, () => {
        // this.props.functionsHandler(null, 'fetchData', {}, true, () => { }, this.state.sortedBy)
      })
      // this.props.functionsHandler(null, 'changeSortBy', defaultt)
    })

  }
  setData = (key, value) => {
    let defaultt = this.state.default
    for (let i = 0; i < defaultt.length; i++) {
      if (defaultt[i].id == key.id) {
        defaultt.splice(i, 1, value)
        break
      }
    }
    this.setState({ default: defaultt })
  }

  setSortType = (headerKey, sortType) => {
    let sortedBy = this.state.sortedBy
    if (Array.isArray(Object.entries(sortedBy)) && Object.entries(sortedBy).length > 0) {
      // let pIndex
      // for (let i = 0; i < sortedBy[0].length; i++) {
      //   const el = sortedBy[0][i];
      //   if (el == headerKey) {
      //     pIndex = i
      //   }
      // }
      // sortType[1][pIndex] = sortType
      if (sortedBy[headerKey]) {
        sortedBy[headerKey] = sortType
      }
      this.setState({ sortedBy }, () => {
        this.props.functionsHandler(null, 'changeSortBy', sortedBy, null, () => {
          // this.props.functionsHandler(null, 'fetchData', this.state.sortedBy, true)
        })
      })
    }
  }

  render() {
    return (
      <div className="w-100 " >
        <div className="flexc " style={{ flexDirection: "column", alignItems: "flex-start", backgroundColor: "#fff", width: "100%" }}>
          <DragDropContext onDragEnd={(result) => this.onDragEnd(result)}>
            <Droppable droppableId="droppablee">
              {(provided) => (
                <div className="" {...provided.droppableProps} ref={provided.innerRef} style={{ backgroundColor: "#fff" }}>
                  {this.state.default.map((item, index) => {
                    return (
                      <>
                        <div style={{ position: "fixed", top: "0", left: "0" }} ref={(el) => (this.setPositionDiv = el)}></div>
                        <Draggable key={item.id ?? item.key} draggableId={item.id ?? item.key} index={index}>
                          {(provided, snapshot) => {
                            if (snapshot.isDragging) {
                              if (!provided.draggableProps) {
                                provided.draggableProps = { style: { boxShadow: "0px 0px 30px #10101090", zIndex: "999" } };
                              }
                              let bound = getBoundingClientRect(this.setPositionDiv.current);
                              const offset = { x: bound.left, y: bound.top };
                              const x = (provided.draggableProps?.style?.left ?? 0) - offset.x;
                              const y = (provided.draggableProps?.style?.top ?? 0) - offset.y;
                              provided.draggableProps.style.left = x;
                              provided.draggableProps.style.top = y;
                              provided.draggableProps.style.boxShadow = "0px 0px 10px #10101020";
                              provided.draggableProps.style.zIndex = "999";
                            }
                            return (
                              <div className="sort flexc" ref={provided.innerRef} {...provided.draggableProps} >
                                <div className="w-100 flexc" style={{ backgroundColor: "#fff" }}>
                                  <div className="flexc " style={{ backgroundColor: "#fff" }}>

                                    <div className="prd-1 flexcc" style={{ width: "15px" }} {...provided.dragHandleProps}>
                                      <img className="" style={{ opacity: 0.8 }} src="/assets/icons/drag-and-drop.svg" width="13px" />
                                    </div>

                                    <div className="br-20 flexcc" style={{ width: "15px", height: 15, backgroundColor: '#eee', border: '1px solid #eee' }} onClick={() => this.crossHandler(item)}>
                                      <img className="" style={{ opacity: 0.6, }} src="/assets/icons/close.svg" width="13px" />
                                    </div>

                                  </div>
                                  <FieldItem width={this.props.width} default={this.state.default} item={item} makeList={this.makeList} setData={this.setData} test={this.state.test} src={item.src} type={item.type} characters={this.state.characters} headers={this.props.headers} setSortType={this.setSortType} />
                                </div>
                              </div>
                            )
                          }}
                        </Draggable>
                      </>
                    );
                  })}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
        <div className="fields-buttons flexc  pt-1" ref={(el) => (this.currentNode = el)} style={{ width: "100%" }}>
          <button className="text-smaller flexc mb-1 px-1" onClick={() => this.openSortView()} style={{ color: '#007aff' }}>
            {/* <img className="" width={18} src="/assets/icons/plus-blue.svg" /> */}
            <p style={{ color: '#007aff' }}>+ {translate('Add Field to sort')}</p>
          </button>
        </div>

        <FixedView ref={(el) => (this.sortView = el)} nodeRef={this.currentNode} showFocus={false} topOffset={0} xOffset={-10}>
          <div className='bg-white br-10 p-1 shadow-3 ' >
            <div className="w-100  sc-gray2" style={{ maxHeight: 350, overflowY: 'auto' }}>
              <div className="px-1">
                <div className=" flexc py-1 w-100 " >
                  {/* <img src="/assets/icons/gantt/search.svg" className="mld-1" /> */}
                  <input
                    type="search"
                    id="InputID"
                    name="name"
                    className='py-1 px-2 br-5 w-100' style={{ backgroundColor: '#F2F2F7', border: '1px solid #F2F2F7' }}
                    placeholder={translate("Find a field ...")}
                    value={this.state.search}
                    onChange={(e) => this.searchInput(e)}
                  />
                </div>
                {this.state.characters.map((item, index) => {
                  if (this.state.default.find((i) => (i.id == item.id || i.key == item.key))) {
                    return (
                      <></>
                    )
                  } else {
                    return (
                      <div className="flexc p-1 my-1" onClick={() => this.selectHandler(item)} key={index} style={{ cursor: "pointer", width: "100%" }}>
                        <img className="mx-1" style={{ opacity: 0.8 }} src={item.src} width="10px" />
                        <p className="text-smaller">{item.information?.label}</p>
                      </div>
                    );
                  }
                })}
              </div>
            </div>
          </div>
        </FixedView>
      </div>
    );
  }
}

export default SortedBy;
